import React, { createContext, useState } from 'react';
import { ExtractionSequenceEntity } from '@/interfaces';
import { ITechnicianForm } from '@/pages/authenPages/Extraction/type';

export interface IExtractionContext {
  technicians?: ITechnicianForm;
  setTechnicians?: React.Dispatch<
    React.SetStateAction<ITechnicianForm | undefined>
  >;
  sequenceToReextract?: ExtractionSequenceEntity[];
  setSequenceToReextract?: React.Dispatch<
    React.SetStateAction<ExtractionSequenceEntity[] | undefined>
  >;
}
export const ExtractionContext = createContext<IExtractionContext>({});

export const ExtractionProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const [technicians, setTechnicians] = useState<ITechnicianForm>();
  const [sequenceToReextract, setSequenceToReextract] =
    useState<ExtractionSequenceEntity[]>();

  return (
    <ExtractionContext.Provider
      value={{
        technicians,
        setTechnicians,
        sequenceToReextract,
        setSequenceToReextract,
      }}
    >
      {children}
    </ExtractionContext.Provider>
  );
};
